import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

// MUI stuff
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import formStyles from '../../utils/formStyles';
import theme from '../../utils/theme';

const styles = {
    ...formStyles,
    ...theme,
    invisibleSeparator: {
        border: 'none',
        margin: 4
    },
    visibleSeparator: {
        width: '100%',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        marginBottom: 15
    },
    commentImage: {
        maxWidth: '100%',
        height: 100,
        width: 100,
        objectFit: 'cover',
        borderRadius: '50%'
    },
    commentData: {
        marginLeft: 20
    }
};

class Comments extends Component {
    render() {

        const { classes, comments } = this.props;

        return (
            <Grid container sx={{ py: 2, px: 4 }}>
                {
                    comments.map((comment, index) => {
                        const { body, createdAt, userImage, userHandle } = comment;
                        return (
                            <Fragment key={createdAt}>
                                <Grid item sm={12}>
                                    <Grid container>
                                        <Grid item sm={2} xs={3}>
                                            <img src={userImage} alt="comment" className={classes.commentImage} />
                                        </Grid>
                                        <Grid item sm={10} xs={9}>
                                            <div className={classes.commentData}>
                                                <Typography
                                                    variant="h5"
                                                    component={Link}
                                                    to={`/users/${userHandle}`}
                                                    color="primary">
                                                    {userHandle}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {dayjs(createdAt).format('h:mm: a, MMMM DD YYYY')}
                                                </Typography>
                                                <hr className={classes.invisibleSeparator} />
                                                <Typography variant="body1"> {body} </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {index !== comments.length - 1 && (
                                    <Grid item xs={12}>
                                        <Divider style={{ margin: '8px 0' }} />
                                    </Grid>
                                )}
                            </Fragment>
                        )
                    })
                }
            </Grid>
        )
    }
}

Comments.propTypes = {
    comments: PropTypes.array.isRequired
};

export default withStyles(styles)(Comments);
